import type {
  ActionScope,
  ActionSurface,
  ObjectActionContext,
  ObjectKind,
} from "@/object-actions/types";
import { objectKindKey } from "@/object-actions/types";
import { useMemo } from "react";

export interface BuildObjectActionContextParams {
  kind: ObjectKind;
  surface: ActionSurface;
  scope?: ActionScope;
  permissions?: Record<string, boolean>;
  state?: Partial<ObjectActionContext["state"]>;
}

export function buildObjectActionContext({
  kind,
  surface,
  scope = "canonical",
  permissions = {},
  state = {},
}: BuildObjectActionContextParams): ObjectActionContext {
  return {
    kind,
    surface,
    scope,
    permissions,
    state,
  };
}

export function useObjectActionContext(
  params: BuildObjectActionContextParams,
): ObjectActionContext {
  const { kind, surface, scope, permissions, state } = params;
  return useMemo(
    () =>
      buildObjectActionContext({
        kind,
        surface,
        scope,
        permissions,
        state,
      }),
    [kind, surface, scope, permissions, state],
  );
}

export function useObjectKindKey(kind: ObjectKind): string {
  return useMemo(() => objectKindKey(kind), [kind]);
}
